import {
  FETCH_ESSENTIAL_EXTRAS_REQUEST,
  FETCH_ESSENTIAL_EXTRAS_SUCCESS,
  FETCH_ESSENTIAL_EXTRAS_FAILURE,
  FETCH_EXTRAS_DATA_REQUEST,
  FETCH_EXTRAS_DATA_SUCCESS,
  FETCH_EXTRAS_DATA_FAILURE
} from '../../actionTypes/essentialExtrasActionTypes'

const initialState = {
  data: {
    id: '',
    name: '',
    price: {},
    variants: [],
    specialOfferPrice: {},
    specialOfferText: ''
  },
  meta: {
    errorDetail: '',
    requestDone: false
  }
}

const buildRequestState = oldState => {
  const { meta: oldMeta = {} } = oldState
  const newState = {
    ...oldState,
    data: {
      ...initialState.data
    },
    meta: {
      ...oldMeta,
      errorDetail: '',
      requestDone: false
    }
  }
  return newState
}

const buildSuccessState = (oldState, payload) => {
  const { data } = payload
  const { data: oldData = {}, meta: oldMeta = {} } = oldState
  const newState = {
    ...oldState,
    data: {
      ...oldData,
      id: data[0].id
    },
    meta: {
      ...oldMeta,
      errorDetail: '',
      requestDone: true
    }
  }
  return newState
}

const buildFailureState = (oldState, payload) => {
  const { errorDetail } = payload
  const { data: oldData = {}, meta: oldMeta = {} } = oldState
  const newState = {
    ...oldState,
    data: {
      ...oldData
    },
    meta: {
      ...oldMeta,
      errorDetail,
      requestDone: true
    }
  }
  return newState
}

const buildExtraDataRequestState = oldState => {
  const { data: oldData = {}, meta: oldMeta = {} } = oldState
  const newState = {
    ...oldState,
    data: {
      ...oldData
    },
    meta: {
      ...oldMeta,
      errorDetail: '',
      extrasRequestDone: false
    }
  }
  return newState
}

const buildExtraDataSuccessState = (oldState, payload) => {
  const { name, price, variants, specialOfferPrice, specialOfferText } = payload
  const { data: oldData = {}, meta: oldMeta = {} } = oldState
  const newState = {
    ...oldState,
    data: {
      ...oldData,
      name,
      price,
      variants,
      specialOfferPrice,
      specialOfferText
    },
    meta: {
      ...oldMeta,
      errorDetail: '',
      extrasRequestDone: true
    }
  }
  return newState
}

const buildExtraDataFailureState = (oldState, payload) => {
  const { errorDetail } = payload
  const { data: oldData = {}, meta: oldMeta = {} } = oldState
  const newState = {
    ...oldState,
    data: {
      ...oldData
    },
    meta: {
      ...oldMeta,
      errorDetail,
      extrasRequestDone: true
    }
  }
  return newState
}

const essentialExtrasReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case FETCH_ESSENTIAL_EXTRAS_REQUEST:
      return buildRequestState(state, payload)
    case FETCH_ESSENTIAL_EXTRAS_SUCCESS:
      return buildSuccessState(state, payload)
    case FETCH_ESSENTIAL_EXTRAS_FAILURE:
      return buildFailureState(state, payload)
    case FETCH_EXTRAS_DATA_REQUEST:
      return buildExtraDataRequestState(state, payload)
    case FETCH_EXTRAS_DATA_SUCCESS:
      return buildExtraDataSuccessState(state, payload)
    case FETCH_EXTRAS_DATA_FAILURE:
      return buildExtraDataFailureState(state, payload)
    default:
      return state
  }
}

export { initialState, essentialExtrasReducer }
